import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';

import { SaveButton, CancelButton } from './buttons';

export const BasicFooter = ({ saveButtonText, saveDisabled, cancelButtonText }) => (
  <Stack horizontal tokens={{ childrenGap: 16 }}>
    <SaveButton buttonText={saveButtonText} disabled={saveDisabled} />
    <CancelButton buttonText={cancelButtonText} />
  </Stack>
);
BasicFooter.propTypes = {
  saveButtonText: PropTypes.string,
  saveDisabled: PropTypes.bool,
  cancelButtonText: PropTypes.string,
};
BasicFooter.defaultProps = {
  saveButtonText: undefined,
  saveDisabled: false,
  cancelButtonText: undefined,
};
